export default "__VITE_ASSET__BTSusXJC__"